var FilterParam = /* @__PURE__ */ ((FilterParam2) => {
  FilterParam2["TitleInclude"] = "titleInclude[]";
  FilterParam2["CampaignTypes"] = "campaignTypes[]";
  FilterParam2["RetailPrice"] = "retailPrice[]";
  FilterParam2["RetailerIds"] = "retailerIds[]";
  FilterParam2["CategoryIds"] = "categoryIds[]";
  FilterParam2["SubcategoryIds"] = "subCategoryIds[]";
  FilterParam2["BrandIds"] = "brandIds[]";
  FilterParam2["SiteId"] = "siteId";
  FilterParam2["VersionId"] = "versionId";
  return FilterParam2;
})(FilterParam || {});
const getFilterParamKeyFromValue = (value) => {
  const entry = Object.entries(FilterParam).find(([, filterValue]) => {
    return filterValue === value;
  });
  return entry == null ? void 0 : entry[0];
};
export {
  FilterParam,
  getFilterParamKeyFromValue
};
//# sourceMappingURL=filters.js.map
